import { render, staticRenderFns } from "./TermoAceiteForm.vue?vue&type=template&id=285e0427&lang=html"
import script from "./TermoAceiteForm.vue?vue&type=script&lang=js"
export * from "./TermoAceiteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports